import { render, staticRenderFns } from "./my-footer.vue?vue&type=template&id=0ac20907&scoped=true&"
var script = {}
import style0 from "./my-footer.vue?vue&type=style&index=0&id=0ac20907&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac20907",
  null
  
)

export default component.exports